// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, mergeWithCss } from "@adl/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel | CartLineModel;
    extendedStyles?: TypographyPresentationProps;
    isSmall?: boolean;
    labelOverride?: string;
}

const productPreviousPurchaseStyles: TypographyPresentationProps = {
    weight: 600,
    color: "success",
    css: css`
        letter-spacing: 0;
        line-height: ${({ isSmall }: any) => (isSmall ? 9 : 17)}px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: ${({ isSmall }: any) => (isSmall ? 76 : 132)}px;
        width: auto;
        padding: ${({ isSmall }: any) => (isSmall ? "4px 0" : "4px 12px")};
        border: 1px solid ${color("success")};
        border-radius: ${({ isSmall }: any) => (isSmall ? 9 : 13)}px;
        background: ${color("success.light")};
    `,
};

const ProductPreviousPurchase: FC<OwnProps> = ({ product, labelOverride, extendedStyles, isSmall = false }) => {
    const [styles] = useState(() => mergeWithCss(productPreviousPurchaseStyles, extendedStyles));
    if (
        !product.properties ||
        !product.properties.previousPurchased ||
        product.properties.previousPurchased.toLowerCase() !== "true"
    ) {
        return null;
    }

    return (
        <Typography {...styles} data-test-selector="ProductPreviousPurchase" size={isSmall ? 8 : 12} {...{ isSmall }}>
            {labelOverride ?? translate("Previous Purchase")}
        </Typography>
    );
};

export default ProductPreviousPurchase;
